import { Box, Dialog, Typography } from "@mui/material";
import AvailabilityCard from "app/components/AllAvailability/AvailabilityCard";
import FareharborAvailabilityCard from "app/components/AllAvailability/FareharborAvailabilityCard";
import { useAvailabilities } from "../AvailabilitiesProvider";
import { FareharborAvailability } from "lib/features/item/types";
import { Availability } from "lib/features/availability/types";

const ItemDetailModal = () => {
  const { selectedSlot, setSelectedSlot } = useAvailabilities();

  const isOpen = selectedSlot !== null;
  const handleClose = () => setSelectedSlot(null);

  if (!selectedSlot) {
    return (
      <Dialog
        open={false}
        onClose={handleClose}
        fullWidth
        PaperProps={{
          sx: { borderRadius: 2, maxWidth: "707px", maxHeight: "90vh" },
        }}
      >
        <Typography sx={{ textAlign: "center", py: 4, color: "#666" }}>
          No availability selected.
        </Typography>
      </Dialog>
    );
  }

  const { item, availability, isFareharbor } = selectedSlot;

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2, maxWidth: "707px", maxHeight: "90vh" },
      }}
    >
      <Box sx={{ maxHeight: "80vh", overflow: "auto" }}>
        {(item.item_type === 1 || item.item_type === 3) && (
          <AvailabilityCard
            item={item}
            availability={availability as Availability}
            onClose={handleClose}
          />
        )}
        {item.item_type === 4 && (
          <FareharborAvailabilityCard
            item={item}
            availability={availability as FareharborAvailability}
            onClose={handleClose}
          />
        )}
      </Box>
    </Dialog>
  );
};

export default ItemDetailModal;
